import type { QueryFnParams } from '@libs/data-access/queries'
import { httpServices } from '@libs/data-access/queries'

import type { DpaeSchema } from './types/contract.dpae.schema'

export type FetchDpaeForContractOptions = QueryFnParams<{
  pathParams: {
    user_contract_id: number
  }
}>

export const fetchDpaeForContract = async (
  opts: FetchDpaeForContractOptions
) => {
  const response = await httpServices.core.get<DpaeSchema>(
    `/employee_management/contracts/${opts.pathParams.user_contract_id}/dpaes`
  )

  return response.data
}

export type PostDpaeForContractOptions = QueryFnParams<{
  pathParams: {
    user_contract_id: number
  }
}>

export const postDpaeForContract = async (opts: PostDpaeForContractOptions) => {
  const response = await httpServices.core.post<DpaeSchema>(
    `/employee_management/contracts/${opts.pathParams.user_contract_id}/dpaes`
  )

  return response.data
}

export type PostBulkDpaeForContractsOptions = QueryFnParams<{
  queryParams: {
    contract_ids: number[]
  }
}>

export const postBulkDpaeForContracts = async (
  opts: PostBulkDpaeForContractsOptions
) => {
  const response = await httpServices.core.post(
    `/employee_management/contracts/dpaes/bulk_create`,
    opts.queryParams
  )

  return response.data
}
